import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { RequestsService } from '../../_shared/services/requests.service'
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms'
import { HelperFunctions } from '../../_shared/utils/helper-functions'

declare var jQuery: any

@Component({
  selector: 'app-nutrition',
  templateUrl: './nutrition.component.html',
  styleUrls: ['./nutrition.component.scss'],
})
export class NutritionComponent implements OnInit {
  addNutritionForm: FormGroup
  editNutritionForm: FormGroup

  constructor(
    private requestService: RequestsService,
    private fb: FormBuilder,
    private helperFunctions: HelperFunctions
  ) {}

  @Input() cropName
  @Input() countryName
  @Input() inputsToSelect
  @Input() servicesToSelect
  @Input() savedInputs
  @Input() savedServices
  @Input() retrieveName: (inputId: string) => void
  @Input() removeInput: (index: number) => void
  @Input() removeService: (index: number) => void
  @Input() checkPublishStatus: (status: string, content) => void
  @Input() videosToSelect

  @Output() publishId = new EventEmitter<string>()
  @Output() publishStatus = new EventEmitter<string>()

  nutPage = 1
  count = 10
  editNutritionisSuccess: boolean
  createNutritionisSuccess: boolean
  model: any
  status: string
  message: string
  searchItem: string
  loading: boolean
  editNutritionError: boolean
  createNutritionError: boolean
  isLoadingNutrition: boolean
  nutritionInfo: any
  filterNutritionInfo: any
  editNutritionInfoData: any
  nutritionId: string
  deleteNutritionData: any
  deleteNutritionisSuccess: boolean
  deleteNutritionError: boolean
  isAddingNutrient: boolean
  isEditingNutrient: boolean
  isDeletingNutrient: boolean
  totalLogos: Array<File> = []
  totalLogoNames = []
  totalFiles: Array<File> = []
  totalFileNames = []
  selectedLanguage: string
  isPublishing: string
  newInputsArray: any
  newServicesArray: any

  appendToFilename(filename, string) {
    let dotIndex = filename.lastIndexOf('.')
    if (dotIndex == -1) return filename + string
    else
      return (
        filename.substring(0, dotIndex) + string + filename.substring(dotIndex)
      )
  }

  changeImage(event, index) {
    let time_stamp = new Date().getTime()
    if (<File>event.target.files && <File>event.target.files[0]) {
      if (index === 0 && typeof this.totalLogos[index] === 'undefined') {
        this.totalLogos.unshift(<File>event.target.files[0])
        this.totalLogoNames.unshift(
          this.appendToFilename(
            <File>event.target.files[0].name,
            '_' + time_stamp
          )
        )
      } else {
        this.totalLogos[index] = <File>event.target.files[0]
        this.totalLogoNames[index] = this.appendToFilename(
          <File>event.target.files[0].name,
          '_' + time_stamp
        )
      }
    }
  }

  changeFiles(event, index) {
    let time_stamp = new Date().getTime()
    if (<File>event.target.files && <File>event.target.files[0]) {
      if (index === 0 && typeof this.totalFiles[index] === 'undefined') {
        this.totalFiles.unshift(<File>event.target.files[0])
        this.totalFileNames.unshift(
          this.appendToFilename(
            <File>event.target.files[0].name,
            '_' + time_stamp
          )
        )
      } else {
        this.totalFiles[index] = <File>event.target.files[0]
        this.totalFileNames[index] = this.appendToFilename(
          <File>event.target.files[0].name,
          '_' + time_stamp
        )
      }
    }
  }

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  editorStyle = {
    height: '100px',
    marginBottom: '10px',
  }

  ngOnInit() {
    this.selectedLanguage = localStorage.getItem('selected_language')
    this.addNutritionForm = this.fb.group({
      role: '',
      prevention: '',
      symptoms: '',
      position: ['', Validators.required],
      name: ['', Validators.required],
      input: [],
      service: [],
      fertilizer_logo: this.fb.array([]),
      media: this.fb.array([]),
    })

    this.editNutritionForm = this.fb.group({
      role: '',
      prevention: '',
      symptoms: '',
      position: ['', Validators.required],
      name: ['', Validators.required],
      input: [],
      service: [],
      fertilizer_logo: this.fb.array([]),
      media: this.fb.array([]),
    })
    this.getNutritionData()
  }

  addFertilizerLogo(): FormArray {
    return this.addNutritionForm.get('fertilizer_logo') as FormArray
  }

  editFertilizerLogo(): FormArray {
    return this.editNutritionForm.get('fertilizer_logo') as FormArray
  }

  newFertilizer(): FormGroup {
    return this.fb.group({
      logo_image: '',
      logo_name: '',
      position: '',
      dose: '',
      units: '',
    })
  }

  addFertilizer() {
    this.addFertilizerLogo().push(this.newFertilizer())
  }

  editFertilizer() {
    this.editFertilizerLogo().push(this.newFertilizer())
  }

  removeAddFertilizer(index) {
    this.addFertilizerLogo().removeAt(index)
    this.totalLogos.splice(index)
    this.totalLogoNames.splice(index)
  }

  removeEditFertilizer(index) {
    this.editFertilizerLogo().removeAt(index)
    this.totalLogos.splice(index)
    this.totalLogoNames.splice(index)
  }

  addNutritionMedia(): FormArray {
    return this.addNutritionForm.get('media') as FormArray
  }

  editNutritionMedia(): FormArray {
    return this.editNutritionForm.get('media') as FormArray
  }

  newMedia(): FormGroup {
    return this.fb.group({
      position: '',
      photo_url: '',
      video_url: '',
    })
  }

  addMedia() {
    this.addNutritionMedia().push(this.newMedia())
  }

  editMedia() {
    this.editNutritionMedia().push(this.newMedia())
  }

  removeAddMedia(index) {
    this.addNutritionMedia().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  removeEditMedia(index) {
    this.editNutritionMedia().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  getNutritionData() {
    this.isAddingNutrient ||
    this.isEditingNutrient ||
    this.isDeletingNutrient ||
    this.isPublishing
      ? (this.isLoadingNutrition = false)
      : (this.isLoadingNutrition = true)

    this.requestService
      .dash_get(
        `nutrition/${this.countryName}/${this.cropName}/${this.selectedLanguage}`,
        null
      )
      .subscribe((res) => {
        this.isLoadingNutrition = false
        let sortedNutritionInfo = []

        res.data
          ? (sortedNutritionInfo = res.data.sort(
              (a: any, b: any) => a.position - b.position
            ))
          : null
        this.nutritionInfo = sortedNutritionInfo
        this.filterNutritionInfo = sortedNutritionInfo
      })
  }

  addNutrient() {
    this.loading = true
    let formData = new FormData()
    let fertilizerLogos = []
    let nutritionMedia = []

    if (this.totalLogos && this.totalLogos.length > 0) {
      for (let j = 0; j < this.totalLogos.length; j++) {
        this.totalLogos[j] && this.totalLogoNames[j]
          ? formData.append(
              'logo_images[]',
              this.totalLogos[j],
              this.totalLogoNames[j]
            )
          : null
      }
    }

    this.addNutritionForm.value.fertilizer_logo.forEach((element, index) => {
      let logoUrl = this.totalLogoNames[index]
        ? '/images/' + this.totalLogoNames[index].replace(/ /g, '')
        : ''

      let logoObject = {
        logo_image: logoUrl,
        logo_name: element.logo_name,
        position: element.position,
        dose: element.dose,
        units: element.units,
      }

      fertilizerLogos.push(logoObject)
    })

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.addNutritionForm.value.media.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : ''

      let mediaObject = {
        position: element.position,
        photo_url: imageUrl,
        video_url: element.video_url,
      }

      nutritionMedia.push(mediaObject)
    })

    formData.append('symptoms', this.addNutritionForm.value.symptoms)
    formData.append('roles', this.addNutritionForm.value.role)
    formData.append('name', this.addNutritionForm.value.name)
    formData.append('position', this.addNutritionForm.value.position)
    formData.append('prevention', this.addNutritionForm.value.prevention)
    formData.append('fertilizer_logo', JSON.stringify(fertilizerLogos))
    formData.append('media', JSON.stringify(nutritionMedia))
    formData.append('language', this.selectedLanguage)
    formData.append('input', this.addNutritionForm.value.input)
    formData.append('service', this.addNutritionForm.value.service)

    this.requestService
      .dash_putWithImage(
        `nutrition/add-order/${this.countryName}/${this.cropName}`,
        formData
      )
      .subscribe(
        (response) => {
          this.loading = false
          if (response.success) {
            this.createNutritionisSuccess = true
            this.message = 'Nutrition info added successfully'
            this.status = 'success'
            this.isAddingNutrient = true
            this.getNutritionData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetNutritionCreateModal()
          } else if (!response.success) {
            this.message = response.message
            this.status = 'error'
            this.createNutritionError = true
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (error) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.createNutritionError = true
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  editNutritionInfoDetails(data: object, status: string) {
    this.isEditingNutrient = true
    this.editNutritionInfoData = data
    this.nutritionId = this.editNutritionInfoData.id
    this.publishId.emit(this.editNutritionInfoData.id)
    let publishStatus =
      this.editNutritionInfoData.status === 'inactive' ? 'inactive' : 'active'
    this.publishStatus.emit(publishStatus)
    this.isPublishing = status
    this.selectedLanguage = this.editNutritionInfoData.language

    this.editNutritionInfoData.input
      ? this.editNutritionInfoData.input.map((element) => {
          this.retrieveName(element)
        })
      : null

    this.savedServices = this.editNutritionInfoData.service

    this.editNutritionForm.patchValue({
      role: this.editNutritionInfoData.roles,
      prevention: this.editNutritionInfoData.prevention,
      symptoms: this.editNutritionInfoData.symptoms,
      position: this.editNutritionInfoData.position,
      name: this.editNutritionInfoData.name,
    })
    let sortedFerlizerLogos = []
    let sortedMedia = []

    this.editNutritionInfoData.fertilizer_logo
      ? (sortedFerlizerLogos = this.editNutritionInfoData.fertilizer_logo.sort(
          (a: any, b: any) => a.position - b.position
        ))
      : null
    this.editNutritionForm.setControl(
      'fertilizer_logo',
      this.setExistingFertilizerLogos(sortedFerlizerLogos)
    )

    this.editNutritionInfoData.media
      ? (sortedMedia = this.editNutritionInfoData.media.sort(
          (a: any, b: any) => a.position - b.position
        ))
      : null
    this.editNutritionForm.setControl(
      'media',
      this.setExistingNutritionMedia(sortedMedia)
    )
  }

  setExistingFertilizerLogos(fertLogos): FormArray {
    const formArray = new FormArray([])
    fertLogos
      ? fertLogos.forEach((element) => {
          formArray.push(
            this.fb.group({
              logo_image: element.logo_image,
              logo_name: element.logo_name,
              position: element.position,
              dose: element.dose,
              units: element.units,
            })
          )
        })
      : null
    return formArray
  }

  setExistingNutritionMedia(nutritionMedia): FormArray {
    const formArray = new FormArray([])
    nutritionMedia
      ? nutritionMedia.forEach((element) => {
          formArray.push(
            this.fb.group({
              photo_url: element.photo_url,
              position: element.position,
              video_url: element.video_url,
            })
          )
        })
      : null
    return formArray
  }

  updateNutritionInfo() {
    this.loading = true
    let formData = new FormData()
    let fertilizerLogos = []
    let nutritionMedia = []

    if (this.totalLogos && this.totalLogos.length > 0) {
      for (let j = 0; j < this.totalLogos.length; j++) {
        this.totalLogos[j] && this.totalLogoNames[j]
          ? formData.append(
              'logo_images[]',
              this.totalLogos[j],
              this.totalLogoNames[j]
            )
          : null
      }
    }

    this.editNutritionForm.value.fertilizer_logo.forEach((element, index) => {
      let logoUrl = this.totalLogoNames[index]
        ? '/images/' + this.totalLogoNames[index].replace(/ /g, '')
        : element.logo_image

      let logoObject = {
        logo_image: logoUrl,
        logo_name: element.logo_name,
        position: element.position,
        dose: element.dose,
        units: element.units,
      }

      fertilizerLogos.push(logoObject)
    })

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalLogos[j] && this.totalLogoNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.editNutritionForm.value.media.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : element.photo_url

      let mediaObject = {
        position: element.position,
        photo_url: imageUrl,
        video_url: element.video_url,
      }

      nutritionMedia.push(mediaObject)
    })

    let newInputsArray = []
    let newServicesArray = []
    let savedInputsIds = []

    this.savedInputs
      ? this.savedInputs.map((each) => {
          savedInputsIds.push(each.id)
        })
      : null

    newInputsArray = [
      ...(this.editNutritionForm.value.input || []),
      ...(savedInputsIds || []),
    ]
    this.newInputsArray = Array.from(new Set(newInputsArray))

    newServicesArray = [
      ...(this.editNutritionForm.value.service || []),
      ...(this.editNutritionInfoData.service || []),
    ]
    this.newServicesArray = Array.from(new Set(newServicesArray))

    formData.append('crop', this.cropName)
    formData.append('symptoms', this.editNutritionForm.value.symptoms)
    formData.append('roles', this.editNutritionForm.value.role)
    formData.append('name', this.editNutritionForm.value.name)
    formData.append('position', this.editNutritionForm.value.position)
    formData.append('prevention', this.editNutritionForm.value.prevention)
    formData.append('fertilizer_logo', JSON.stringify(fertilizerLogos))
    formData.append('media', JSON.stringify(nutritionMedia))
    formData.append('language', this.selectedLanguage)
    formData.append('input', this.newInputsArray)
    formData.append('service', this.newServicesArray)

    this.requestService
      .dash_putWithImage(
        `nutrition/update/${this.countryName}/${this.nutritionId}`,
        formData
      )
      .subscribe(
        (response) => {
          this.loading = false
          if (response.success) {
            this.editNutritionisSuccess = true
            this.isEditingNutrient = true
            this.message = 'Nutrition info edited successfully'
            this.status = 'success'
            this.getNutritionData()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.resetNutritionEditModal()
          } else if (!response.success) {
            this.message = response.message
            this.editNutritionError = true
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (error) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.editNutritionError = true
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  deleteNutritionInfoDetails(data: object) {
    this.deleteNutritionData = data
  }

  deleteNutrition(id) {
    this.loading = true
    this.requestService
      .dash_delete(id, `nutrition/delete/${this.countryName}/${this.cropName}`)
      .subscribe(
        (response) => {
          this.loading = false
          this.deleteNutritionisSuccess = true
          this.isDeletingNutrient = true
          this.getNutritionData()
        },
        (errorResponse) => {
          this.loading = false
          this.deleteNutritionError = true
        }
      )
  }

  resetDeleteNutritionModal() {
    jQuery('#deleteNutritionModal').modal('hide')
    this.deleteNutritionisSuccess = false
    this.deleteNutritionError = false
    this.isDeletingNutrient = false
  }

  resetNutritionEditModal() {
    jQuery('#editNutritionInfoModal').modal('hide')
    this.editNutritionForm.reset()
    this.resetFiles()
    this.editNutritionisSuccess = false
    this.editNutritionError = false
    this.isEditingNutrient = false
    this.savedServices = []
    this.savedInputs = []
  }

  resetNutritionCreateModal() {
    jQuery('#createNutritionInfoModal').modal('hide')
    this.addNutritionForm.reset()
    this.createNutritionisSuccess = false
    this.createNutritionError = false
    this.resetFiles()
    this.isAddingNutrient = false
    this.addFertilizerLogo().controls = []
    this.addNutritionMedia().controls = []
  }

  filterNutritionFunction() {
    this.searchItem = jQuery('#searchBoxNutrition').val()
    this.filterNutritionInfo = this.nutritionInfo.filter(
      (input) =>
        input.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#createNutritionInfoModal').on('hidden.bs.modal', () => {
        this.resetNutritionCreateModal()
      })
      jQuery('#editNutritionInfoModal').on('hidden.bs.modal', () => {
        this.resetNutritionEditModal()
      })
      jQuery('#deleteNutritionModal').on('hidden.bs.modal', () => {
        this.resetDeleteNutritionModal()
      })
    })
  }

  resetFiles() {
    this.totalLogoNames = []
    this.totalLogos = []
    this.totalFiles = []
    this.totalFileNames = []
  }

  onVideoChange(event, index) {
    let videoTag

    jQuery(document).ready(() => {
      if (this.isEditingNutrient) {
        videoTag = jQuery('#edit-vid-tag' + index)[0]
      } else {
        videoTag = jQuery('#add-vid-tag' + index)[0]
      }
      videoTag.load()
    })
  }
}
